import React from 'react';
import { Banknote } from 'lucide-react';
import { COUNTRIES } from '.';

export const defaultFundQuestions = [
  {
    id: 'logo',
    placeholder: 'logo',
    title: 'uploadLogo',
    type: 'avatar',
    image: <Banknote size={60} className='file-icon' />,
    mandatory: false,
  },
  {
    id: 'name',
    title: 'name',
    placeholder: 'name',
    type: 'text',
    mandatory: true,
  },
  {
    id: 'description',
    type: 'textarea',
    title: 'description',
    placeholder: 'description',
    mandatory: true,
  },
  {
    id: 'manager',
    type: 'text',
    title: 'manager',
    placeholder: 'manager',
    mandatory: false,
  },
  {
    id: 'website',
    type: 'text',
    title: 'website',
    placeholder: 'website',
    mandatory: false,
  },
  {
    id: 'taxId',
    type: 'text',
    title: 'taxId',
    placeholder: 'taxId',
    mandatory: false,
  },
  {
    id: 'type',
    type: 'select',
    title: 'type',
    placeholder: 'type',
    answers: ['hedge_fund', 'mutual_fund', 'other'],
    mandatory: false,
  },
  {
    id: 'domicile',
    type: 'select',
    title: 'domicile',
    placeholder: 'domicile',
    answers: COUNTRIES,
    literals: 'countries',
    mandatory: false,
  },
  {
    id: 'registrationNumber',
    type: 'text',
    title: 'registrationNumber',
    placeholder: 'registrationNumber',
    mandatory: false,
  },
  {
    id: 'inceptionDate',
    type: 'date',
    title: 'inceptionDate',
    placeholder: 'inceptionDate',
    mandatory: false,
  },
  {
    id: 'currency',
    title: 'currency',
    placeholder: 'currency',
    type: 'select',
    answers: ['USD', 'EUR', 'GBP', 'CHF', 'CNY', 'HKD', 'JPY', 'AUD'],
    mandatory: false,
  },
  {
    id: 'investmentStrategy',
    type: 'textarea',
    title: 'investmentStrategy',
    placeholder: 'investmentStrategy',
    mandatory: false,
  },
  {
    id: 'contactName',
    type: 'text',
    title: 'contactName',
    placeholder: 'contactName',
    mandatory: false,
  },
  {
    id: 'contactEmail',
    type: 'email',
    title: 'contactEmail',
    placeholder: 'contactEmail',
    mandatory: false,
  },
];
